import { atomWithKey as atom } from "./atomWithKey";
import { IMultiTripBookingOfferResponse } from "../Types/Interface/IMultiBooking";
import { TrainType as ITrainType, TrainType } from "../../Orchestrator/Types/Types/TrainTypes";
import { IMultiBooking } from "../Types/Index";
import dayjs from "dayjs";

export const isMultiBookingStateAtom = atom<boolean>({
    key: "isMultiBookingStateAtom",
    default: false
})

export interface IMultiBookingOfferResponseAtom {
    outbound: IMultiTripBookingOfferResponse | null,
    inbound: IMultiTripBookingOfferResponse | null
}

export const multiBookingOfferResponseAtom = atom<IMultiBookingOfferResponseAtom>({
    key: "multiBookingOfferResponseAtom",
    default: {
        outbound: null,
        inbound: null
    }
})

export const multiBookingFormValuesAtom = atom<IMultiBooking | null>({
    key: "multiBookingFormValuesAtom",
    default: null
})

export const multiBookingTravelDatesAtom = atom<{
    start: dayjs.Dayjs,
    end: dayjs.Dayjs
} | null>({
    key: "multiBookingTravelDatesAtom",
    default: null
})

export interface IMultiBookingTrainOffer {
    date: string // 2025-11-22
    outbound: {
        selected: boolean,
        train?: ITrainType
    },
    inbound?: {
        selected: boolean;
        train?: ITrainType
    }
}

export const multiBookingSelectedTrainsAtom = atom<IMultiBookingTrainOffer[]>({
    key: "multiBookingSelectedTrainsAtom",
    default: []
})

export interface IMoneySummary {
    currency?: string;
    amount?: number;
    scale?: number;
}

export interface IMultiBookingRefundSummary {
    refundableAmount: IMoneySummary | null;
    refundFee: IMoneySummary | null;
}

export const multiBookingRefundSummaryAtom = atom<IMultiBookingRefundSummary | null>({
    key: "multiBookingRefundSummaryAtom",
    default: null
})

export const multiBookingChangeTrainOffersAtom = atom<TrainType[] | null>({
    key: "multiBookingChangeTrainOffersAtom",
    default: null
})
